import type { SessionState } from "../../runtime/tabSpecStore"
import type { Catalogue } from "../../types/catalogue"

/** No data file, or no session started yet. */
export const IMPORT_FIRST = "Import data first."
/** The words of the workspace's alert for a session that failed without a message. */
export const SESSION_FAILED = "The data session could not be started."
export const BEING_PREPARED = "The data is being prepared."

/**
 * Why the data's variables are not known yet, or null once they are (the
 * codebook is in). Shared by Add table, Build tables from the data and the
 * empty state of a project without a questionnaire: the project has no data
 * (or no session was started yet), the session failed (as the workspace's
 * alert says), or the data is being prepared.
 */
export const dataNotReady = (
  status: SessionState["status"],
  sessionError: string | undefined,
  catalogue: Catalogue | null
): string | null => {
  if (catalogue !== null && catalogue.knownPaths !== null) return null
  if (status === "no-data" || status === "idle") return IMPORT_FIRST
  if (status === "error") return sessionError ?? SESSION_FAILED
  return BEING_PREPARED
}
